import { Select } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import React from 'react';
import classes from '../../../core/style/PrintStyles.module.css';

interface CustomSelectProps {
  label: string;
  inputProps: any;
  required?: boolean;
  disabled?: boolean;
  allowDeselect?: boolean;
  clearable?: boolean;
  searchable?: boolean;
  onChangeCallback?: (value: string | null) => void;
  data?: any[];
}

export function CustomSelect({
  label,
  inputProps,
  required,
  disabled,
  allowDeselect,
  clearable,
  searchable,
  onChangeCallback,
  data
}: CustomSelectProps) {
  const handleChange = (value: string | null, option: any) => {
    // Call the original onChange from form.getInputProps
    if (inputProps?.onChange) {
      inputProps.onChange(value);
    }
    // Call the additional callback (used for cascade clearing)
    if (onChangeCallback) {
      onChangeCallback(value);
    }
  };

  return (
    <Select
      {...inputProps}
      onChange={handleChange}
      label={label}
      withAsterisk={required}
      disabled={disabled}
      allowDeselect={allowDeselect}
      clearable={clearable}
      searchable={searchable}
      nothingFoundMessage={searchable ? 'Nic nenalezeno' : undefined}
      id={'print-input-field'}
      data={data}
      mt={10}
      radius={10}
      classNames={{
        section: classes.section,
        input: classes.input
      }}
      leftSection={<IconChevronDown />}
      rightSection={clearable && inputProps?.value ? undefined : <IconChevronDown />}
    />
  );
}
